/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  GoogleSignupRequest,
  GoogleSignupResponse,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Create the account behind a verified Google ID token. See module docs.
 * @summary Google Signup
 */
export const googleSignup = (
    googleSignupRequest: GoogleSignupRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<GoogleSignupResponse>(
      {url: `/auth/google-signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: googleSignupRequest, signal
    },
      options);
    }




export const getGoogleSignupMutationKey = () => ['googleSignup'] as const;

export const getGoogleSignupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof googleSignup>>, TError,GoogleSignupMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof googleSignup>>, TError,GoogleSignupMutationVariables, TContext> => {

const mutationKey = getGoogleSignupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof googleSignup>>, GoogleSignupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  googleSignup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GoogleSignupMutationResult = NonNullable<Awaited<ReturnType<typeof googleSignup>>>
    export type GoogleSignupMutationBody = GoogleSignupRequest
    export type GoogleSignupMutationError = HTTPValidationError
    export type GoogleSignupMutationVariables = {data: GoogleSignupRequest}

    /**
 * @summary Google Signup
 */
export const useGoogleSignup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof googleSignup>>, TError,GoogleSignupMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof googleSignup>>,
        TError,
        GoogleSignupMutationVariables,
        TContext
      > => {
      return useMutation(getGoogleSignupMutationOptions(options));
    }
